var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drag-handle",
    class: {
      'drag-handle__disabled': _vm.disabled
    }
  }, [_c('icon', {
    staticClass: "drag-handle__icon",
    attrs: {
      "name": "menu"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45561db7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/DragHandle.vue
// module id = 1967
// module chunks = 0